const routes = [
  {
    path: '/:path(.*)',
    component: () => import('@/views/ContentView.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/notfound/:lastPath',
    name: 'NotFound',
    component: () => import('@/views/NotFoundView.vue')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/components/login-components/ResetTempPassword.vue')
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('@/components/login-components/ChangePassword.vue')
  },
  {
    path: '/contact-information',
    name: 'ContactInformation',
    component: () => import('@/components/login-components/ContactInformation.vue')
  },
  {
    path: '/select-programme',
    name: 'SelectProgramme',
    component: () => import('@/components/programme-components/SelectProgramme.vue')
  },
  {
    path: '/style-guide',
    name: 'StyleGuide',
    component: () => import('@/components/style-guide-components/StyleGuide.vue')
  },
  {
    path: '/id-logon',
    name: 'IdLogon',
    component: () => import('@/views/IdLogonView.vue')
  },
  {
    path: '/cookie-consent',
    name: 'CookieConsent',
    component: () => import('@/components/login-components/CookieConsent.vue')
  },
  {
    path: '/id-logon-redirect',
    name: 'IdLogonRedirect',
    component: () => import('@/views/IdLogonRedirectView.vue')
  }
]

export default routes
